module.exports = __webpack_public_path__ + "img/video_icon.943a9f91.png";